import React from 'react';
import { useNavigate } from 'react-router-dom';
import { PageSubTitle } from 'Components/Titles';
import { getUserSheerInfo } from 'State/Integrations';

export const SignUp = ({ subTitle, routes }) => {
  const navigate = useNavigate();

  // check if user is in the middle of sheer ID verification
  // if yes, redirect them to sheer verification page
  // otherwise redirect them to sign up plans
  const navigateToSignUp = async () => {
    try {
      await getUserSheerInfo();
      navigate(routes.sheerIdVerification);
    } catch (error) {
      if (error?.currentStep) {
        navigate(routes.sheerIdVerification);
      } else {
        navigate(routes.signupPlans);
      }
    }
  };

  return (
    <div className="sectionFlex membershipSection" data-testid="myAccountSignUp">
      <div className="flexGrowOne settingsSectionLeft">
        <PageSubTitle text={subTitle} />
      </div>
      <div className="sectionFlex flexDirCol flexGrowTwo settingsSectionRight">
        <button onClick={navigateToSignUp} className="blueLink signUpLink">
          Sign Up
        </button>
      </div>
    </div>
  );
};
